<template>
  <div
    class="mx-auto flex flex-col items-center font-Almarai relative overflow-x-hidden min-h-screen"
  >
    <LogoSvg class="absolute" />

    <div
      class="flex justify-center items-center w-full sm:w-6/12 md:w-4/12 lg:w-3/12 h-24 sm:h-32 md:h-36 mb-4"
    >
      <img src="@/assets/logo-1.webp" alt="logo" class="w-20 sm:w-24 md:w-28" />
    </div>
    <!-- Main Content -->
    <div
      class="flex flex-col justify-center items-center gap-y-4 md:gap-y-6 bg-transparent rounded-md w-full max-w-md sm:max-w-md mx-auto p-4 sm:p-6 md:p-8"
    >
      <div class="my-2 flex flex-col justify-center items-center w-full">
        <h1
          class="text-lg sm:text-xl md:text-2xl font-bold text-white my-2 font-Almarai text-center"
        >
          معلومات الدفع
        </h1>
        <p class="text-white text-center">اسم الباقة: {{ plan?.name }}</p>

        <p class="text-white text-center">قيمة الاشتراك: {{ plan?.price }}</p>
        <!-- daily section -->

        <!-- end of daily -->

        <!-- end of stripe plans -->
      </div>

      <!-- Phone Number Input and Buttons Container -->
      <div
        class="flex flex-col items-center gap-y-3 sm:gap-y-4 justify-center w-full mx-auto my-3"
      >
        <!-- Phone Number Input -->
        <div class="w-full mx-auto">
          <MazPhoneNumberInput
            v-model="phoneNumber"
            default-country-code="SD"
            show-code-on-list
            :preferred-countries="['SD', 'EG', 'SA', 'AE', 'QA']"
            :ignored-countries="['AC']"
            @update="handleUpdate"
            orientation="row"
            class="phone-input w-full"
            color="#0B0C0E"
            :custom-countries-list="translatedCountries"
            :translations="{
              countrySelector: {
                placeholder: 'رمز الدولة',
                error: 'اختر الدولة',
                searchPlaceholder: 'البحث',
              },
              phoneInput: {
                placeholder: 'رقم الهاتف ',
                example: 'مثال:',
              },
            }"
            noExample="false"
          />
        </div>
        <div class="w-full mx-auto flex flex-col gap-3">
          <button
            @click.prevent="redirectUserToProvider"
            :disabled="!isPhoneValid"
            class="inline-flex justify-center items-center gap-2 w-full bg-[#9d2890] hover:bg-[#8a2279] text-gray-100 rounded-md py-3 sm:py-4 text-sm sm:text-base font-semibold transition-colors duration-200"
            :class="
              isPhoneValid
                ? 'bg-[#9d2890] cursor-pointer'
                : 'bg-[#9d289080] cursor-not-allowed'
            "
          >
            <span> متابعة </span>
          </button>
          <button
            @click.prevent="handleBack"
            class="inline-flex justify-center items-center gap-2 w-full border border-gray-400 hover:border-gray-300 text-gray-100 hover:bg-gray-800 rounded-md py-3 sm:py-4 text-sm sm:text-base font-semibold transition-colors duration-200"
          >
            <span> رجوع </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import animationData from "@/assets/loader.json";
import LogoSvg from "@/components/svg/LogoSvg.vue";
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/stores/auth";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";
import { useBravoStore } from "@/stores/Bravo";
export default {
  components: {
    LogoSvg,
    MazPhoneNumberInput,
  },
  data() {
    return {
      color: { gray: { name: "gray", hex: "#111827" } },
      toast: useToast(),
      loaded: false,
      phoneNumber: "",
      countryCode: null,
      phoneError: "",
      translatedCountries: {
        SD: "السودان",
        EG: "مصر",
        SA: "السعودية",
        AE: "الإمارات",
        QA: "قطر",
      },
      results: null,

      lottieOptions: {
        animationData,
        loop: true,
        autoplay: true,
      },
      jsonFile: animationData,
      bravo: {
        bravoAccountId: null,
        amount: 100,
      },

      phoneMetadata: {
        countryCallingCode: null,
        countryCode: null,
        e164: null,
        phoneNumber: null,
      },
      plan: null,
    };
  },

  computed: {
    ...mapState(useBravoStore, ["getPlans"]),
    isPhoneValid() {
      return this.results?.isValid === true;
    },
  },
  methods: {
    ...mapActions(useBravoStore, ["fetchPlans"]),
    ...mapActions(useAuthStore, ["bravoPay"]),

    async loadPlans() {
      try {
        await this.fetchPlans();
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    },

    handleUpdate(event) {
      this.results = event;
      console.log(this.results);
    },

    redirectUserToProvider() {
      if (this.results && this.results.e164) {
        this.phoneNumber = this.results.e164; // Phone number without country code
        this.phoneMetadata = {
          countryCallingCode: this.results.countryCallingCode,
          countryCode: this.results.countryCode,
          e164: this.results.e164,
          phoneNumber: this.results.nationalNumber,
        };
      } else {
        this.toast.error("يرجى إدخال رقم هاتف صحيح");
        return;
      }

      try {
        this.bravoPay(this.phoneNumber, this.phoneMetadata).then((response) => {
          if (response.success) {
            this.$router.push({ name: "bravo.confirm" });
          } else {
            this.toast.error("فشل في الاتصال بمزود الخدمة");
          }
        });
      } catch (error) {
        this.toast.error("فشل التحقق من رقم الهاتف");
      }
    },

    isValidPhoneNumber() {
      // This method is now handled by the MazPhoneNumberInput component
      return this.phoneNumber && !this.phoneError;
    },
    handleBack() {
      localStorage.removeItem("selectedPlan");
      this.$router.go(-1);
    },
  },
  async created() {
    // Load plans when the component is created
    const selectedPlan = localStorage.getItem("selectedPlan");
    if (selectedPlan) {
      this.plan = JSON.parse(selectedPlan);
    } else {
      this.toast.error("خطأ في تحميل بيانات الباقة");
      this.$nextTick(() => {
        this.$router.push({ name: "auth.subscriptions" });
      });
    }
    await this.loadPlans();
  },
};
</script>

<style scoped>
/* Phone Input Styling to match button sizes */
:deep(.phone-input) {
  width: 100% !important;
}

:deep(.phone-input .maz-phone-number-input) {
  width: 100% !important;
}

:deep(.phone-input .maz-phone-number-input__input) {
  height: 48px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  border-radius: 6px !important;
  background-color: #111827 !important;
  border: 1px solid #9d2890 !important;
  color: white !important;
}

:deep(.phone-input .maz-phone-number-input__country-selector) {
  height: 48px !important;
  border-radius: 6px !important;
  background-color: #111827 !important;
  border: 1px solid #9d2890 !important;
  color: white !important;
}

:deep(.phone-input .maz-phone-number-input__country-selector button) {
  height: 100% !important;
  background-color: transparent !important;
  color: white !important;
  padding: 0 12px !important;
}

:deep(.phone-input .maz-phone-number-input__input:focus) {
  border-color: #9d2890 !important;
  box-shadow: 0 0 0 2px rgba(157, 40, 144, 0.2) !important;
}

:deep(.phone-input .maz-phone-number-input__country-selector:focus-within) {
  border-color: #9d2890 !important;
  box-shadow: 0 0 0 2px rgba(157, 40, 144, 0.2) !important;
}

/* Responsive sizing for tablets */
@media (min-width: 640px) {
  :deep(.phone-input .maz-phone-number-input__input) {
    height: 52px !important;
    padding: 16px !important;
    font-size: 16px !important;
  }

  :deep(.phone-input .maz-phone-number-input__country-selector) {
    height: 52px !important;
  }
}

/* Responsive sizing for desktop */
@media (min-width: 768px) {
  :deep(.phone-input .maz-phone-number-input__input) {
    height: 56px !important;
    padding: 16px !important;
    font-size: 16px !important;
  }

  :deep(.phone-input .maz-phone-number-input__country-selector) {
    height: 56px !important;
  }
}

/* Dropdown styling */
:deep(.maz-phone-number-input__country-selector-list) {
  background-color: #111827 !important;
  border: 1px solid #9d2890 !important;
  border-radius: 6px !important;
}

:deep(.maz-phone-number-input__country-selector-list-item) {
  color: white !important;
  background-color: transparent !important;
}

:deep(.maz-phone-number-input__country-selector-list-item:hover) {
  background-color: #9d2890 !important;
}
</style>
